import React from 'react'
import styles from '../loader.jcss'

export default (p_: { inv?: boolean; small?: boolean }) => (
    <div className={`${p_.inv ? styles.itemInv : styles.item} ${p_.small ? styles.itemSm : ''}`}></div>
)
